import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const ShareOutlineIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 5v8.5M15 7l-3-3l-3 3m-4 5v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5"
      ></path>
    </svg>
  );
};

export default ShareOutlineIcon;
